<template>
  <!-- !important has been added here for most of the styles as these are rep theme styles; if these are set we need them to take precedence over our site CSS -->
  <v-style>
    .menu {
      background-color: {{ getMenuBackground }} !important;
    }

    .menu li a {
      color: {{ getMenuForeColor }} !important;
      font-weight: 500;
    }

    .menu li:hover, .active, .router-link-active {
      background-color: {{ getMenuBackgroundRollOver }} !important;
      color: {{ getMenuForeColorRollOver }} !important;
      border-bottom: 2px solid {{ getLinkColor }};
    }

    .router-link-active:hover {
      border-bottom: 0;
    }

    button, input[type='button'], .btn-primary, .btn-primary.disabled, .btn-primary[disabled], fieldset[disabled] .btn-primary, .btn-primary.disabled:hover, .btn-primary[disabled]:hover,
    fieldset[disabled] .btn-primary:hover, .btn-primary.disabled:focus, .btn-primary[disabled]:focus, fieldset[disabled] .btn-primary:focus, .btn-primary.disabled:active,
    .btn-primary[disabled]:active, fieldset[disabled] .btn-primary:active, .btn-primary.disabled.active, .btn-primary.active[disabled], fieldset[disabled] .btn-primary.active {
      background-color: {{ getButtonBackgroundColor }} !important;
      border-color: {{ getButtonBackgroundColor }} !important;
      color: {{ getButtonTextColor }} !important;
      border-radius: 0 !important;
      font-weight: 400 !important;
    }

    .panel-primary {
      border-color: {{ getPanelBackgroundColor }} !important;
      border-radius: 0;
    }

    .panel-primary > .panel-heading {
      background-color: {{ getPanelBackgroundColor }} !important;
      border-color: {{ getPanelBackgroundColor }} !important;
      color: {{ getPanelTextColor }} !important;
    }

    button:hover, input[type='button']:hover, .btn-primary:hover {
      background-color: {{ getButtonBackgroundRollover }} !important;
      border-color: {{ getButtonBackgroundRollover }} !important;
      color: {{ getButtonRolloverText }} !important;
    }

    a {
      color: {{ getLinkColor }} !important;
    }

    a:hover {
      color: {{ getLinkRolloverColor }} !important;
    }

    a.list-group-item {
      color: {{ getLinkColor }} !important;
    }

    a.list-group-item:hover {
      color: {{ getLinkColor }} !important;
      text-decoration: none !important;
    }

    .notifications-lowbal .btn-default {
      background: {{ getLowBalanceButtonOptionalNotSelectedActive }} !important;
      color: #333 !important;
      box-shadow: none;
      border: 0;
    }

    .notifications-lowbal .btn-default:hover {
      background: {{ getLowBalanceButtonOptionalNotSelectedHover }} !important;
      border: 1px solid #333 !important;
    }
  </v-style>
</template>

<script>
  import axios from "axios";

  export default {
    name: 'CustomStyles',
    data() {
      return {
        repThemeSettings: '',
        defaultMenuBackgroundColor: "#1473B3",
        defaultBackgroundColor: '#EBEBEB',
        defaultBackgroundRolloverColor: '#055285',
        defaultTextColor: '#FFFFFF',
        defaultButtonBackgroundColor: '#3276b1',
        defaultLinkColor: '#1473B3'
      }
    },
    mounted() {
      this.getRepThemeSettings();
    },
    methods: {
      getRepThemeSettings() {
        this.repThemeSettings = this.$store.getters.getRepThemeSettings;
        // If theme settings don't exist in store we need to fetch them again
        if (this.repThemeSettings === '') {
          axios({
            method: "GET",
            url: this.$httpAxiosBaseUrl() + "RepTheme/GetRepThemeSettings?date=" + new Date().getTime()
          }).then(result => {
            var response = result.data;
            if (response !== '') {
              this.repThemeSettings = response;
              this.$store.commit('setRepThemeSettings', response);
              
              this.$store.commit('setRepThemeLoaded', true);
            }
          }, error => {
            console.log(error);
          });
        }
      }
    },
    computed: {
      getMenuBackground() {
        var menuBackground = this.repThemeSettings.MenuBackground;
        return menuBackground === '' || menuBackground === undefined ? this.defaultMenuBackgroundColor : menuBackground;
      },
      getMenuForeColor() {
        var menuForeColor = this.repThemeSettings.MenuForecolor;
        return menuForeColor === '' || menuForeColor === undefined ? this.defaultTextColor : menuForeColor;
      },
      getMenuBackgroundRollOver() {
        var menuBackgroundRollOver = this.repThemeSettings.MenuBackgroundRollOver;
        return menuBackgroundRollOver === '' || menuBackgroundRollOver === undefined ? this.defaultBackgroundRolloverColor : menuBackgroundRollOver;
      },
      getMenuForeColorRollOver() {
        var menuForeColorRollOver = this.repThemeSettings.MenuForecolorRollOver;
        return menuForeColorRollOver === '' || menuForeColorRollOver === undefined ? this.defaultTextColor : menuForeColorRollOver;
      },
      getButtonBackgroundColor() {
        var buttonBackgroundColor = this.repThemeSettings.ButtonBackgroundColor;
        return buttonBackgroundColor === '' || buttonBackgroundColor === undefined ? this.defaultButtonBackgroundColor : buttonBackgroundColor;
      },
      getButtonTextColor() {
        var buttonTextColor = this.repThemeSettings.ButtonTextColor;
        return buttonTextColor === '' || buttonTextColor === undefined ? this.defaultTextColor : buttonTextColor;
      },
      getButtonBackgroundRollover() {
        var buttonBackgroundRollover = this.repThemeSettings.ButtonBackgroundRollOver;
        return buttonBackgroundRollover === '' || buttonBackgroundRollover === undefined ? this.defaultButtonBackgroundColor : buttonBackgroundRollover;
      },
      getButtonRolloverText() {
        var buttonBackgroundRolloverText = this.repThemeSettings.ButtonRollOverText;
        return buttonBackgroundRolloverText === '' || buttonBackgroundRolloverText === undefined ? this.defaultTextColor : buttonBackgroundRolloverText;
      },
      getLinkColor() {
        var linkColor = this.repThemeSettings.LinkColor;
        return linkColor === '' || linkColor === undefined ? this.defaultLinkColor : linkColor;
      },
      getLinkRolloverColor() {
        var linkRolloverColor = this.repThemeSettings.LinkRolloverColor;
        return linkRolloverColor === '' || linkRolloverColor === undefined ? this.defaultBackgroundColor : linkRolloverColor;
      },
      getPanelBackgroundColor() {
        var panelBackgroundColor = this.repThemeSettings.PanelBackgroundColor;
        return panelBackgroundColor === '' || panelBackgroundColor === undefined ? this.defaultBackgroundColor : panelBackgroundColor;
      },
      getPanelTextColor() {
        var panelTextColor = this.repThemeSettings.PanelTextColor;
        return panelTextColor === '' || panelTextColor === undefined ? this.defaultLinkColor : panelTextColor;
      },
      getLowBalanceButtonOptionalNotSelectedActive() {
        var lowBalanceButtonOptionalNotSelectedActive = this.repThemeSettings.LowBalanceButtonOptionalNotSelectedActive;
        return lowBalanceButtonOptionalNotSelectedActive === '' || lowBalanceButtonOptionalNotSelectedActive === undefined ? this.defaultBackgroundColor : lowBalanceButtonOptionalNotSelectedActive;
      },
      getLowBalanceButtonOptionalNotSelectedHover() {
        var lowBalanceButtonOptionalNotSelectedHover = this.repThemeSettings.LowBalanceButtonOptionalNotSelectedHover;
        return lowBalanceButtonOptionalNotSelectedHover === '' || lowBalanceButtonOptionalNotSelectedHover === undefined ? this.defaultBackgroundColor : lowBalanceButtonOptionalNotSelectedHover;
      }
    }
  }
</script>

<style>
  @import url('../../assets/css/customer.css');
  @import url('../../assets/css/responsive.css');
</style>

